export const GET_PROFILE_DETAILS = "GET_PROGRAM_DETAILS";
